module.exports = __webpack_public_path__ + "static/media/5p.4401b294.png";